module.exports = __webpack_public_path__ + "static/media/tubi-big.c460b253.jpg";